// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"8035e76d","453":"55c068ab"}[chunkId] + ".chunk.js";
};